import { debug } from "/vodalys/.jslibs/";
const log = debug('TalkTo:UidProvider:Exemple')

export default function () {

    const paramsMatch = window.location.hash.match(/#\/?(.*)/);
    if (!paramsMatch) {
        log('Undefined UID')
        return
    } else {
        let [, uid] = paramsMatch;
        
        log(`uid ${uid}`)
        return uid
    }


}